import React from 'react';

const NoMatch = () => (
	<section className='container'>
		<div className='grid-row margin-top-basic margin-bottom-small'>
			<div className='grid-item item-s-12'>
				<h1 className='margin-bottom-small'>404</h1>
				<a href='/' className='button'>Regresar</a>
			</div>
		</div>

	</section>
)

export default NoMatch;



// WEBPACK FOOTER //
// ./src/components/NoMatch.js